import { useState } from 'react';
import { SearchConfigType } from './../../../types/search';

export const useSearchConfig = () => {
  const [config] = useState<SearchConfigType>(() => {
    const searchMountElement = document.getElementById('search-root');
    const contentListingMountElement = document.getElementById('content-listing-root');
    const documentsListingMountElement = document.getElementById('documents-listing-root');
    const portalListingMountElement = document.getElementById('portal-listing-root');
    const mountElement =
      searchMountElement || contentListingMountElement || documentsListingMountElement || portalListingMountElement;

    return {
      siteSearchApi: mountElement?.dataset.siteSearchApi || '/api/sitesearch/',
      documentsOnly: mountElement?.dataset.documentsOnly === 'true',
      paginationDisplayLimit: Number.parseInt(mountElement?.dataset.paginationDisplayLimit || '10', 10),
      documentContentTypes: mountElement?.dataset.documentContentType,
      documentAssetTypeGuid: mountElement?.dataset.documentAssetTypeGuid,
      invoicePaymentUrl: mountElement?.dataset.invoicePaymentUrl || '',
      labels: {
        noResultsText: mountElement?.dataset.labelsNoResultsText || 'No results found',
        searchCtaLabel: mountElement?.dataset.labelsSearchCtaLabel || 'Search',
        clearFiltersLabel: mountElement?.dataset.labelsClearFiltersLabel || 'Clear filters',
        applyFiltersLabel: mountElement?.dataset.labelsApplyFiltersLabel || 'Apply filters',
        showingResultsForLabel: mountElement?.dataset.labelsShowingResultsForLabel || 'Showing results for:',
        filtersLabel: mountElement?.dataset.labelsFiltersLabel || 'Filters',
        closeLabel: mountElement?.dataset.labelsCloseLabel || 'Close',
        filterByLabel: mountElement?.dataset.labelsFilterByLabel || 'Filter by',
        sortByLabel: mountElement?.dataset.labelsSortByLabel || 'Sort by',
        downloadLabel: mountElement?.dataset.labelsDownloadLabel || 'Download',
        downloadsLabel: mountElement?.dataset.labelsDownloadsLabel || 'Downloads',
        resultCountLabel: mountElement?.dataset.labelsResultCountLabel || 'result(s)',
        sortByMostRecentLabel: mountElement?.dataset.labelsSortByMostRecentLabel || 'Most Recent',
        sortByRelevanceLabel: mountElement?.dataset.labelsSortByRelevanceLabel || 'Relevance',
        sortByAlphabeticalLabel: mountElement?.dataset.labelsSortByAlphabeticalLabel || 'A-Z',
        sortByAlphabeticalDescendingLabel: mountElement?.dataset.labelsSortByAlphabeticalDescendingLabel || 'Z-A',
        allProductsLabel: mountElement?.dataset.labelsAllProductsLabel || 'All products',
        allSolutionsLabel: mountElement?.dataset.labelsAllSolutionsLabel || 'All solutions',
        allCaseStudiesLabel: mountElement?.dataset.labelsAllCaseStudiesLabel || 'All case studies',
        allInsightsLabel: mountElement?.dataset.labelsAllInsightsLabel || 'All insights',
        allNewsLabel: mountElement?.dataset.labelsAllNewsLabel || 'All news',
        allDownloadsLabel: mountElement?.dataset.labelsAllDownloadsLabel || 'All downloads',
        productsLabel: mountElement?.dataset.labelsProductsLabel || 'Products',
        solutionsLabel: mountElement?.dataset.labelsSolutionsLabel || 'Solutions',
        caseStudiesLabel: mountElement?.dataset.labelsCaseStudiesLabel || 'Case studies',
        insightsLabel: mountElement?.dataset.labelsInsightsLabel || 'Insights',
        newsLabel: mountElement?.dataset.labelsNewsLabel || 'News',
        otherLabel: mountElement?.dataset.labelsOtherLabel || 'Other',
        prevPageLabel: mountElement?.dataset.labelsPreviousPageLabel || 'Previous',
        nextPageLabel: mountElement?.dataset.labelsNextPageLabel || 'Next',
        videoLabel: mountElement?.dataset.labelsVideoLabel || 'Video',
        viewLabel: mountElement?.dataset.labelsViewLabel || 'View',
        lastUpdatedLabel: mountElement?.dataset.labelsLastUpdatedLabel || 'Last updated:',
        noResultsTitleLabel: mountElement?.dataset?.labelsNoResultsTitleLabel || 'No results found',
        noResultsDescriptionLabel:
          mountElement?.dataset.labelsNoResultsDescriptionLabel ||
          '<p>Please try amending your search term or applying filters.</p>',
        noResultsCtaLabel: mountElement?.dataset.labelsNoResultsCtaLabel || 'Amend search',
        searchResultForLabel: mountElement?.dataset.labelsSearchResultForLabel || 'Search results for:',
        downloadAllCtaLabel: mountElement?.dataset.labelsDownloadAllCtaLabel || 'Bulk download',
        filterBtnLabel: mountElement?.dataset.labelsFilterBtnLabel || 'Filter',
        applyFilterBtnLabel: mountElement?.dataset.labelsApplyFilterBtnLabel || 'Apply filters',
        viewingResultsLabel:
          mountElement?.dataset.labelsViewingResultsLabel ||
          'Viewing {startResult} - {endResult} of {totalResults} results',
        payButtonLabel: mountElement?.dataset.labelsPayButtonLabel || 'Pay',
        filterNoResultsTitleLabel: mountElement?.dataset.labelsFilterNoResultsTitleLabel || 'No results found',
        filterNoResultsDescriptionLabel:
          mountElement?.dataset.labelsFilterNoResultsDescriptionLabel || 'Please try amending the applied filters.',
        dateNoResultsTitleLabel: mountElement?.dataset.labelsDateNoResultsTitleLabel || 'No results found',
        dateNoResultsDescriptionLabel:
          mountElement?.dataset.labelsDateNoResultsDescriptionLabel ||
          'Please try selecting another day or date range.',
      },
    };
  });

  return config;
};
